import React from 'react';

const CodeOfConduct = () => {
  return (
    <div className="min-h-screen bg-white pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-5xl font-outfit font-800 text-black mb-8">
          Code of Conduct
        </h1>
        
        <div className="w-24 h-1 bg-crimson mb-12"></div>

        <div className="space-y-8 text-gray-700 font-outfit font-600">
          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Our Commitment</h2>
            <p className="leading-relaxed">
              AI Day is committed to providing a welcoming, inclusive, and harassment-free experience for everyone, regardless of gender, 
              gender identity and expression, age, sexual orientation, disability, physical appearance, body size, race, ethnicity, 
              religion, technology choices, or any other dimension of diversity.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Expected Behavior</h2>
            <p className="leading-relaxed mb-4">
              All participants are expected to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Be respectful and professional in all interactions</li>
              <li>Use welcoming and inclusive language</li>
              <li>Be collaborative and supportive of fellow participants</li>
              <li>Accept constructive criticism gracefully</li>
              <li>Focus on what is best for the community</li>
              <li>Show empathy towards other community members</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Unacceptable Behavior</h2>
            <p className="leading-relaxed mb-4">
              The following behaviors are considered unacceptable:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Harassment, intimidation, or discrimination in any form</li>
              <li>Offensive comments related to personal characteristics</li>
              <li>Unwelcome sexual attention or advances</li>
              <li>Trolling, insulting, or derogatory comments</li>
              <li>Public or private harassment</li>
              <li>Publishing others' private information without permission</li>
              <li>Other conduct which could reasonably be considered inappropriate</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Reporting Guidelines</h2>
            <p className="leading-relaxed">
              If you experience or witness unacceptable behavior, please report it immediately to the event organizers. 
              All reports will be handled with discretion and confidentiality. Contact information will be provided at each event.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Consequences</h2>
            <p className="leading-relaxed">
              Participants asked to stop any inappropriate behavior are expected to comply immediately. Organizers may take any action 
              deemed appropriate, including warning the offender or expulsion from the event without refund.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Scope</h2>
            <p className="leading-relaxed">
              This Code of Conduct applies to all AI Day event spaces, including workshops, talks, networking sessions, and online platforms 
              associated with the events.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-outfit font-800 text-black mb-4">Contact</h2>
            <p className="leading-relaxed">
              For questions or concerns about this Code of Conduct, please reach out to the AI Anytime team through our official channels.
            </p>
          </section>

          <div className="pt-8 border-t border-gray-800">
            <p className="text-sm text-gray-500">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodeOfConduct;
